<!--
  Angular 15: *ngIf / *ngFor only, no @if blocks.
-->
<div class="dl-page">

  <div class="dl-page__header">
    <div class="dl-page__heading">
      <h1 class="dl-page__title">Feature flags</h1>
      <p class="dl-page__subtitle" *ngIf="!loading">
        {{ rows.length }} tenant(s) — read-only; switch a flag on the tenant's partner page.
      </p>
    </div>
    <div class="dl-page__actions">
      <button
        type="button"
        class="dl-btn dl-btn--ghost"
        (click)="load()"
        [disabled]="refreshing"
        matTooltip="Reload"
        aria-label="Reload">
        <mat-icon *ngIf="!refreshing">refresh</mat-icon>
        <mat-icon *ngIf="refreshing" class="ff-spin">hourglass_empty</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="dl-loading">
    <div class="dl-spinner"></div>
    <p>Loading feature flags for every tenant...</p>
  </div>

  <div *ngIf="error" class="dl-banner dl-banner--error">
    <mat-icon>error</mat-icon>
    <div class="dl-banner__body">{{ error }}</div>
    <button (click)="load()">
      <mat-icon>refresh</mat-icon>
      Try Again
    </button>
  </div>

  <div *ngIf="!loading && !error" [class.dl-is-refreshing]="refreshing">

    <div *ngIf="truncatedBy > 0" class="dl-banner dl-banner--warning">
      <mat-icon>warning</mat-icon>
      <div class="dl-banner__body">
        Only the first {{ rows.length }} tenants were loaded; {{ truncatedBy }} more exist.
      </div>
    </div>

    <div *ngIf="failedRows > 0" class="dl-banner dl-banner--warning">
      <mat-icon>warning</mat-icon>
      <div class="dl-banner__body">
        Feature flags could not be loaded for {{ failedRows }} tenant(s) — their cells are marked, not off.
      </div>
      <button (click)="load()">
        <mat-icon>refresh</mat-icon>
        Retry
      </button>
    </div>

    <div class="dl-card">
      <div class="dl-card__header">
        <h3>Who has what</h3>
        <span class="dl-card__subtitle">{{ filteredRows.length }} of {{ rows.length }}</span>
      </div>

      <!-- Filtering is pure array work against data already in memory: no request, so no
           debounce and nothing to disable while it runs. -->
      <div class="dl-filters ff-filters">
        <div class="dl-field">
          <label class="dl-field__label" for="ffSearch">Search</label>
          <input id="ffSearch" type="text" [(ngModel)]="searchTerm" (input)="applyFilters()"
                 placeholder="Tenant name" class="dl-input" />
        </div>
        <div class="dl-field">
          <label class="dl-field__label" for="ffType">Type</label>
          <select id="ffType" class="dl-select" [(ngModel)]="typeFilter" (change)="applyFilters()">
            <option value="">All types</option>
            <option *ngFor="let type of partnerTypes" [value]="type">{{ type }}</option>
          </select>
        </div>
        <div class="dl-field">
          <label class="dl-field__label" for="ffFeature">Has feature</label>
          <select id="ffFeature" class="dl-select" [(ngModel)]="featureFilter" (change)="applyFilters()">
            <option value="">Any</option>
            <option *ngFor="let column of columns; trackBy: trackByColumn" [value]="column.name">{{ column.label }}</option>
          </select>
        </div>
        <div class="dl-field ff-filters__action">
          <button type="button" class="dl-btn dl-btn--ghost" (click)="clearFilters()">Clear</button>
        </div>
      </div>

      <div class="dl-table-scroll">
        <table class="dl-table dl-table--cards ff-table" dlCardTable>
          <thead>
            <tr>
              <th class="ff-tenant-col">Tenant</th>
              <th *ngFor="let column of columns; trackBy: trackByColumn" class="ff-flag-col">
                {{ column.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredRows; trackBy: trackByRow">
              <td class="ff-tenant-col">
                <a [routerLink]="['/partners', row.tenantId]" class="ff-tenant-link">{{ row.tenantName }}</a>
                <span class="partner-type" [class]="'type-' + (row.type || 'dentist').toLowerCase()">
                  {{ row.type || 'DENTIST' }}
                </span>
              </td>
              <td *ngFor="let column of columns; trackBy: trackByColumn" class="ff-flag-col">
                <span *ngIf="row.flagsFailed" class="ff-cell ff-cell--error"
                      matTooltip="Could not load this tenant's flags">
                  <mat-icon>error_outline</mat-icon>
                </span>
                <span *ngIf="!row.flagsFailed && isOn(row, column)" class="ff-cell ff-cell--on"
                      [matTooltip]="limitTooltip(row, column)">
                  <mat-icon>check</mat-icon>
                  <span class="ff-limit" *ngIf="limitLabel(row, column)">{{ limitLabel(row, column) }}</span>
                </span>
                <span *ngIf="!row.flagsFailed && !isOn(row, column)" class="ff-cell ff-cell--off" aria-label="Off">—</span>
              </td>
            </tr>
            <tr *ngIf="filteredRows.length === 0">
              <td [attr.colspan]="columns.length + 1" class="muted ff-empty">No tenants match the current filters.</td>
            </tr>
          </tbody>
          <tfoot *ngIf="rows.length > 0">
            <tr>
              <td class="ff-tenant-col ff-foot">Enabled for</td>
              <td *ngFor="let column of columns; trackBy: trackByColumn" class="ff-flag-col ff-foot">
                {{ column.enabled }} / {{ rows.length }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
